import { useEmployeeUrl } from 'domain/shared/employee';
import { useOneStopRequestsUrl } from 'domain/shared/oneStop';
import { LinkButton } from 'framework/ui/ui-builder';
import { SECURITY_INCIDENT_REQUEST_ID } from './constants';

const ReportSecurityIncidentButton = () => {
  const { getEmployeeComplianceUrl } = useEmployeeUrl();
  const { getSingleEntityUrl } = useOneStopRequestsUrl();

  const reportSecurityIncidentUrl = `${getSingleEntityUrl(SECURITY_INCIDENT_REQUEST_ID)}?${new URLSearchParams({
    from: getEmployeeComplianceUrl(),
  })}`;

  return (
    <LinkButton color="primary" url={reportSecurityIncidentUrl}>
      Report security incident
    </LinkButton>
  );
};

export default ReportSecurityIncidentButton;
